import { Request } from '@/classes/Request'
import type { AthleticsMessage } from '@/types/enrollments'
import { normalizeAthleticsMessage } from '@/modules/api/get/athleticsConversationMessages'

// DELETE /ajax/athletics/messages/{messageId} (DTA-799 round 11): the author
// soft-deletes their own message within 10 minutes of sending it (409 after).
// Answers with the tombstoned message.
export const athleticsMessage = async (messageId: string): Promise<AthleticsMessage | null> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).delete(
    '/ajax/athletics/messages/' + encodeURIComponent(messageId)
  )
  return response.data?.message ? normalizeAthleticsMessage(response.data.message) : null
}
